<template>
  <!-- Background Image -->
  <NuxtImg
    src="/hero-bg-watercolor-desktop.webp"
    alt="Hero Image"
    class="img-desktop absolute inset-0 w-full h-full object-fill lg:object-fill xl:object-cover"
    decoding="async"
    loading="eager"
    fetchpriority="high"
    :preload="{
      fetchPriority: 'high',
    }"
  />

  <!-- Left Decoration -->
  <!-- Top -->
  <NuxtImg
    src="/hero-purple-decor-left-top-desktop.webp"
    alt="Hero Left Top Decoration"
    class="img-desktop absolute left-0 top-[10%] w-xs flower-sway flower-left wind-3 lg:w-2xs lg:top-[5%] xl:w-xs 2xl:w-sm"
  />

  <!-- Bottom -->
  <NuxtImg
    src="/hero-purple-decor-left-bottom-desktop.webp"
    alt="Hero Left Bottom Decoration"
    class="img-desktop absolute bottom-0 left-[8%] w-sm flower-sway flower-left wind-4 lg:w-md lg:left-[10%] xl:w-xl xl:left-[12%]"
  />

  <!-- Right Decoration -->
  <!-- Top -->
  <NuxtImg
    src="/hero-purple-decor-right-top-desktop.webp"
    alt="Hero Right Top Decoration"
    class="img-desktop absolute right-0 top-[9%] w-[192px] flower-sway flower-right wind-5 lg:w-[224px] lg:top-[7%] xl:w-3xs 2xl:w-2xs"
  />
</template>
